import { BP42SubmitResult } from '@r1-frontend/bp42/actions/thunk/submit';
import { BP42Callbacks } from '@r1-frontend/bp42/hooks/useBP42PopupForm';

class BP42Callback {
    // We don`t initiate a property by direct assignment, but through the flushCallbacks method... Go to the Hell TS!
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore TS2564: Property callbacksMap has no initializer and is not definitely assigned in the constructor.
    private callbacksMap: BP42Callbacks;

    constructor() {
        this.flushCallbacks();
    }

    public flushCallbacks(): void {
        this.callbacksMap = {
            onSubmit: () => void 0,
            onClose: () => void 0,
            onCloseResultPopup: () => void 0,
        };
    }

    public onSubmit(result: BP42SubmitResult): void {
        this.callbacksMap.onSubmit && this.callbacksMap.onSubmit(result);
    }

    public onClose(): void {
        this.callbacksMap.onClose && this.callbacksMap.onClose();
    }

    public onCloseResultPopup(): void {
        this.callbacksMap.onCloseResultPopup && this.callbacksMap.onCloseResultPopup();
    }

    public injectByName(name: keyof BP42Callbacks, callback: () => void) {
        this.callbacksMap[name] = callback;
    }

    public injectOnSubmit(callback: (result: BP42SubmitResult) => void) {
        this.callbacksMap.onSubmit = callback;
    }
}

export const callbacks = new BP42Callback();

export default BP42Callback;
